var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _vm.componentReady
      ? _c(
          "div",
          {
            staticClass:
              "panel bg-transparent columns large-6 medium-12 large-centered",
          },
          [
            _c(
              "table",
              {
                staticClass: "dataTable Display",
                staticStyle: { width: "100%" },
              },
              [
                _c("thead", [
                  _c("tr", [
                    _c(
                      "td",
                      { staticClass: "text-center", attrs: { colspan: "2" } },
                      [
                        _c("h5", {
                          staticClass: "no-margin",
                          domProps: {
                            textContent: _vm._s(
                              _vm.t("forms.new_individual.IC_0000")
                            ),
                          },
                        }),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("tbody", [
                  _c("tr", [
                    _c(
                      "td",
                      { staticClass: "text-center", attrs: { colspan: "2" } },
                      [
                        _c("a", {
                          staticClass: "button mini radius no-margin",
                          attrs: {
                            href: "https://mail.google.com",
                            target: "_blank",
                          },
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.t("forms.new_individual.IC_0013")
                            ),
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.t("forms.add_a_contractor.IC_0018")
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.personalInfo.Email,
                            expression: "personalInfo.Email",
                          },
                        ],
                        staticClass: "no-margin",
                        attrs: {
                          placeholder: _vm.t("register.enter_email"),
                          type: "text",
                          maxlength: "100",
                        },
                        domProps: { value: _vm.personalInfo.Email },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.personalInfo,
                              "Email",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.emailError && _vm.displayError
                        ? _c("small", {
                            staticClass: "error",
                            domProps: {
                              textContent: _vm._s(
                                _vm.t("member_basic_edit.IC_0037")
                              ),
                            },
                          })
                        : _vm._e(),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", { attrs: { colspan: "2" } }, [
                      _c("div", [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.t("password_change.password_new_must")
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.t("password_change.password_length")
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("li", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.t("password_change.password_uppercase")
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("li", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.t("password_change.password_number")
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("li", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.t("password_change.password_common")
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("li", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.t(
                                  "password_change.password_constitutive_characters"
                                )
                              ),
                            },
                          }),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.t("forms.login_cred.IC_0004")
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.personalInfo.Password,
                            expression: "personalInfo.Password",
                          },
                        ],
                        staticClass: "no-margin",
                        attrs: {
                          placeholder: _vm.t("register.enter_password"),
                          type: "password",
                          autocomplete: "off",
                        },
                        domProps: { value: _vm.personalInfo.Password },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.personalInfo,
                              "Password",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.passwordError && _vm.displayError
                        ? _c("small", {
                            staticClass: "error",
                            domProps: {
                              textContent: _vm._s(
                                _vm.t("eInvoicing.password_meet_requirements")
                              ),
                            },
                          })
                        : _vm._e(),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.t("forms.login_cred.IC_0006")
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.personalInfo.PasswordMatch,
                            expression: "personalInfo.PasswordMatch",
                          },
                        ],
                        staticClass: "no-margin",
                        attrs: {
                          placeholder: _vm.t("register.re_enter_password"),
                          type: "password",
                          autocomplete: "off",
                        },
                        domProps: { value: _vm.personalInfo.PasswordMatch },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.personalInfo,
                              "PasswordMatch",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.passwordMatchError && _vm.displayError
                        ? _c("small", {
                            staticClass: "error",
                            domProps: {
                              textContent: _vm._s(
                                _vm.t("xajax.newcontractor.server.IC_0014")
                              ),
                            },
                          })
                        : _vm._e(),
                    ]),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "table",
              {
                staticClass: "dataTable Display",
                staticStyle: { width: "100%" },
              },
              [
                _c("thead", [
                  _c("tr", [
                    _c(
                      "td",
                      { staticClass: "text-center", attrs: { colspan: "2" } },
                      [
                        _c("h5", {
                          staticClass: "no-margin",
                          domProps: {
                            textContent: _vm._s(
                              _vm.t("forms.new_individual.IC_0014")
                            ),
                          },
                        }),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("tbody", [
                  _c("tr", [
                    _c("td", [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.t("forms.new_contractor_contact.IC_0001")
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.personalInfo.Firstname,
                            expression: "personalInfo.Firstname",
                          },
                        ],
                        staticClass: "no-margin",
                        attrs: { type: "text", maxlength: "20" },
                        domProps: { value: _vm.personalInfo.Firstname },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.personalInfo,
                              "Firstname",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.firstnameError && _vm.displayError
                        ? _c("small", {
                            staticClass: "error",
                            domProps: {
                              textContent: _vm._s(
                                _vm.t("xajax.mycontactinfo.server.IC_0008")
                              ),
                            },
                          })
                        : _vm._e(),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.t("forms.new_contractor_contact.IC_0002")
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.personalInfo.Lastname,
                            expression: "personalInfo.Lastname",
                          },
                        ],
                        staticClass: "no-margin",
                        attrs: { type: "text", maxlength: "20" },
                        domProps: { value: _vm.personalInfo.Lastname },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.personalInfo,
                              "Lastname",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.lastnameError && _vm.displayError
                        ? _c("small", {
                            staticClass: "error",
                            domProps: {
                              textContent: _vm._s(
                                _vm.t("xajax.mycontactinfo.server.IC_0009")
                              ),
                            },
                          })
                        : _vm._e(),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.t("forms.new_contractor_contact.IC_0003")
                          ),
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.personalInfo.Title,
                            expression: "personalInfo.Title",
                          },
                        ],
                        staticClass: "no-margin",
                        attrs: { type: "text", maxlength: "40" },
                        domProps: { value: _vm.personalInfo.Title },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.personalInfo,
                              "Title",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.t("forms.new_contractor_contact.IC_0005")
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.personalInfo.Tel,
                            expression: "personalInfo.Tel",
                          },
                        ],
                        staticClass: "no-margin",
                        attrs: { type: "text", maxlength: "14" },
                        domProps: { value: _vm.personalInfo.Tel },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.personalInfo,
                              "Tel",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.telError && _vm.displayError
                        ? _c("small", {
                            staticClass: "error",
                            domProps: {
                              textContent: _vm._s(
                                _vm.t("xajax.mycontactinfo.server.IC_0011")
                              ),
                            },
                          })
                        : _vm._e(),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.t("forms.new_contractor_contact.IC_0006")
                          ),
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.personalInfo.Cell,
                            expression: "personalInfo.Cell",
                          },
                        ],
                        staticClass: "no-margin",
                        attrs: { type: "text", maxlength: "14" },
                        domProps: { value: _vm.personalInfo.Cell },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.personalInfo,
                              "Cell",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.t("forms.new_contractor_contact.IC_0008")
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.personalInfo.Street,
                            expression: "personalInfo.Street",
                          },
                        ],
                        staticClass: "no-margin",
                        attrs: { type: "text", maxlength: "58" },
                        domProps: { value: _vm.personalInfo.Street },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.personalInfo,
                              "Street",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.streetError && _vm.displayError
                        ? _c("small", {
                            staticClass: "error",
                            domProps: {
                              textContent: _vm._s(
                                _vm.t("xajax.mycontactinfo.server.IC_0014")
                              ),
                            },
                          })
                        : _vm._e(),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.t("forms.new_contractor_contact.IC_0009")
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.personalInfo.City,
                            expression: "personalInfo.City",
                          },
                        ],
                        staticClass: "no-margin",
                        attrs: { type: "text", maxlength: "30" },
                        domProps: { value: _vm.personalInfo.City },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.personalInfo,
                              "City",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.cityError && _vm.displayError
                        ? _c("small", {
                            staticClass: "error",
                            domProps: {
                              textContent: _vm._s(
                                _vm.t("xajax.mycontactinfo.server.IC_0015")
                              ),
                            },
                          })
                        : _vm._e(),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.t("forms.new_contractor_contact.IC_0011")
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.localCountryId,
                              expression: "localCountryId",
                            },
                          ],
                          staticClass: "no-margin",
                          staticStyle: { "box-sizing": "border-box" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.localCountryId = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c("option", {
                            attrs: { value: "0" },
                            domProps: {
                              textContent: _vm._s(
                                _vm.t("admin.edit_question.IC_0000")
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _vm._l(
                            _vm.displayData.geoInfo.countries,
                            function (country) {
                              return _c("option", {
                                domProps: {
                                  value: country.CountryID,
                                  textContent: _vm._s(country.Name),
                                },
                              })
                            }
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.countryError && _vm.displayError
                        ? _c("small", {
                            staticClass: "error",
                            domProps: {
                              textContent: _vm._s(
                                _vm.t("xajax.mycontactinfo.server.IC_0017")
                              ),
                            },
                          })
                        : _vm._e(),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.localCountryId !== "0"
                    ? _c("tr", [
                        _c("td", [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.t("forms.new_contractor_contact.IC_0010")
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "required" }, [
                            _vm._v("*"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.localProvinceId,
                                  expression: "localProvinceId",
                                },
                              ],
                              staticClass: "no-margin",
                              staticStyle: { "box-sizing": "border-box" },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.localProvinceId = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                              },
                            },
                            [
                              _c("option", {
                                attrs: { value: "0" },
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.t("admin.edit_question.IC_0000")
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.getProvinces(), function (province) {
                                return _c("option", {
                                  domProps: {
                                    value: province.zone_id,
                                    innerHTML: _vm._s(province.Name),
                                  },
                                })
                              }),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm.provinceError && _vm.displayError
                            ? _c("small", {
                                staticClass: "error",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.t("xajax.mycontactinfo.server.IC_0016")
                                  ),
                                },
                              })
                            : _vm._e(),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.t("forms.new_contractor_contact.IC_0012")
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.personalInfo.Postal,
                            expression: "personalInfo.Postal",
                          },
                        ],
                        staticClass: "no-margin",
                        attrs: { type: "text", maxlength: "14" },
                        domProps: { value: _vm.personalInfo.Postal },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.personalInfo,
                              "Postal",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.postalError && _vm.displayError
                        ? _c("small", {
                            staticClass: "error no-margin",
                            domProps: {
                              textContent: _vm._s(
                                _vm.t("xajax.mycontactinfo.server.IC_0018")
                              ),
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.postalMatchError && _vm.displayError
                        ? _c("small", {
                            staticClass: "error",
                            domProps: {
                              textContent: _vm._s(
                                _vm.t("member_basic_edit.IC_0115")
                              ),
                            },
                          })
                        : _vm._e(),
                    ]),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "table",
              {
                staticClass: "dataTable Display",
                staticStyle: { width: "100%" },
              },
              [
                _c("thead", [
                  _c("tr", [
                    _c(
                      "td",
                      { staticClass: "text-center", attrs: { colspan: "2" } },
                      [
                        _c("h5", {
                          staticClass: "no-margin",
                          domProps: {
                            textContent: _vm._s(
                              _vm.t("forms.new_individual.IC_0031")
                            ),
                          },
                        }),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("tbody", [
                  _c("tr", [
                    _c("td", {
                      staticClass: "text-center",
                      attrs: { colspan: "2" },
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.t("forms.new_individual.IC_0032")
                        ),
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      { staticClass: "text-center", attrs: { colspan: "2" } },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.agreementCheck,
                              expression: "agreementCheck",
                            },
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.agreementCheck)
                              ? _vm._i(_vm.agreementCheck, null) > -1
                              : _vm.agreementCheck,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.agreementCheck,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.agreementCheck = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.agreementCheck = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.agreementCheck = $$c
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "required" }, [_vm._v("*")]),
                        _vm._v(" "),
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.t("forms.new_individual.IC_0033")
                            ),
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", {
                      staticClass: "text-center",
                      attrs: { colspan: "2" },
                      domProps: {
                        textContent: _vm._s(
                          _vm.t("forms.new_individual.IC_0007")
                        ),
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      { staticClass: "text-center", attrs: { colspan: "2" } },
                      [
                        _c("img", {
                          staticStyle: { "margin-bottom": "10px" },
                          attrs: {
                            src: _vm.captchaSource,
                            alt: "CAPTCHA",
                            width: "84",
                            height: "27",
                          },
                        }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "fa fa-refresh",
                          staticStyle: { "font-size": "20px" },
                          on: { click: _vm.resetCaptcha },
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.personalInfo.Captcha,
                              expression: "personalInfo.Captcha",
                            },
                          ],
                          staticClass: "no-margin",
                          attrs: { type: "text", maxlength: "4" },
                          domProps: { value: _vm.personalInfo.Captcha },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.personalInfo,
                                "Captcha",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm.captchaError && _vm.displayError
                          ? _c("small", {
                              staticClass: "error",
                              domProps: {
                                textContent: _vm._s(
                                  _vm.t("xajax.newcontractor.server.IC_0034")
                                ),
                              },
                            })
                          : _vm._e(),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      { staticClass: "text-center", attrs: { colspan: "2" } },
                      [
                        _c("button", {
                          staticClass: "tiny radius marginTop",
                          domProps: {
                            textContent: _vm._s(
                              _vm.t("forms.are_you_preregistered.IC_0128")
                            ),
                          },
                          on: { click: _vm.newIndividual },
                        }),
                      ]
                    ),
                  ]),
                ]),
              ]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.componentReady
      ? _c("div", { staticClass: "row" }, [_vm._m(0)])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "columns" }, [
      _c("i", { staticClass: "fa fa-spinner fa-spin fa-2x" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }